export default (Logger, apiKey, options) => {
  if (!apiKey || !Logger) {
    return console;
  }

  return Logger.createLogger(apiKey, options);
};
